import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Catalog} from "../../../services/interface/catalogs/catalog";
import CustomSelect from "../../../components/general/CustomSelect";
import * as IconMaterial from "@mui/icons-material";
import * as IconFontAwesome from "react-icons/fa6";
import {ItemInfo, ItemInfoSpouse} from "../../components/ViewData";
import {SelectOptionInterface} from "../../../services/interface/catalogs/select-option-interface";
import {useTaxPayerStorage} from "../../../services/storage/TaxPayerStorage";
// import {useFindLocations} from "../../../services/apis/apiRuc";
import NotPermissionComponent from "../../dashboard/NotPermissionComponent";
import NoRecords from "../../components/NoRecords";
import {EstablishmentsSriInterface} from "../../../services/interface/sri/information-sri-interface";

interface Props {

}
export default function Locations({}: Props) {
    const { t } = useTranslation("global") as { t: (key: string) => string };
    const styleIcon = 'max-w-[20px] max-h-[20px] min-w-[20px] min-h-[20px]';
    const [option, setOption] = useState<Catalog | undefined>()
    const [options, setOptions] = useState<SelectOptionInterface[] | undefined>()
    const [info, setInfo] = useState<EstablishmentsSriInterface[] | undefined>();
    const [location, setLocation] = useState<EstablishmentsSriInterface | undefined>()

    const person = useTaxPayerStorage(data => data.data)

    // const {
    //     mutate: findLocations,
    //     data: successLocations,
    //     error: errorLocations,
    //     isPending: loadingLocations,
    // } = useFindLocations()

    useEffect(() => {
        if ((person?.accountant || person?.taxIdentificationNumber) && person.establishments && person.establishments.length > 0) {
            // findLocations({
            //     identifier: person?.accountant ? person?.accountant : person?.taxIdentificationNumber,
            //     msj: t('locations')
            // })
            setInfo(person.establishments)
        }
    }, [person]);

    // useEffect(() => {
    //     if (successLocations) {
    //         setInfo(successLocations)
    //     }
    // }, [successLocations]);
    function getName(value: string | undefined, separator: boolean) {
        if (!value) {
            return ''
        }
        return separator ? ` - ${value}` : ` ${value}`;
    }

    useEffect(() => {
        if (info && info.length > 0) {
            setOptions(info.map((item, index) => {
                return {
                    ...item,
                    idSelect: item.establishmentNumber ? parseInt(item.establishmentNumber) : index,
                    descriptionData: `#${item?.establishmentNumber ?? (index + 1)}${getName(item.address?.type, false)}${getName(item.address?.country, false)}${getName(item.address?.prov, true)}${getName(item.address?.cant, true)}`
                }
            }))
        }
    }, [info]);

    useEffect(() => {
        if (options && options.length > 0) {
            setOption(options[0])
        }
    }, [options]);

    useEffect(() => {
        if (option && info) {
            const opt = info.filter((item, index) => {
                const id = item.establishmentNumber ? parseInt(item.establishmentNumber) : index;
                if(id === option?.idSelect) {
                    return item
                }
            })
            setLocation(opt && opt.length > 0 ? opt[0] : undefined)
        }
    }, [option, info]);

    return(
        <div className={'flex flex-col gap-3'}>
            <h3>{t('establishments')}</h3>
            <NotPermissionComponent
                className={'min-h-[50px]'}
                title={'/tax_payer/establishmentAddresses'}
                // loading={loadingLocations}
                // error={errorLocations}
                component={info ?
                    <>
                        <CustomSelect
                            label={t('locations')}
                            value={option}
                            setValue={setOption}
                            {...{options}}
                        />
                        <div className={'mt-1 custom-card py-3 px-3 flex flex-col gap-3 '}>
                            <div className={'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4'}>
                                <ItemInfo
                                    label={t('province')}
                                    text={location?.address?.prov}
                                    icon={<IconMaterial.LocationOn className={styleIcon}/>}
                                />
                                <ItemInfo
                                    label={t('canton')}
                                    text={location?.address?.cant}
                                    icon={<IconMaterial.LocationOn className={styleIcon}/>}
                                />
                                <ItemInfo
                                    label={t('city')}
                                    text={location?.address?.country}
                                    icon={<IconMaterial.LocationOn className={styleIcon}/>}
                                />
                                <ItemInfo
                                    label={t('parish')}
                                    text={location?.address?.parr}
                                    icon={<IconMaterial.LocationOn className={styleIcon}/>}
                                />
                                <ItemInfo
                                    className={'sm:col-span-2 lg:col-span-4'}
                                    label={t('street')}
                                    text={location?.address?.streetName}
                                    icon={<IconFontAwesome.FaRoad className={styleIcon}/>}
                                />
                            </div>
                            <div className={'border border-t-1 border-t-secondary border-transparent pt-3 ' +
                                'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4'}>
                                <ItemInfoSpouse
                                    label={t('establishmentNumber')}
                                    text={location?.establishmentNumber}
                                />
                                <ItemInfoSpouse
                                    label={t('number')}
                                    text={location?.address?.houseNumber}
                                />
                                <ItemInfoSpouse
                                    label={t('establishmentStatus')}
                                    text={location?.establishmentStatus}
                                />
                                <ItemInfoSpouse
                                    label={t('businessName')}
                                    text={location?.businessName}
                                />
                                <ItemInfoSpouse
                                    label={t('startActivitiesDate')}
                                    text={location?.startActivitiesDate}
                                />
                                <ItemInfoSpouse
                                    label={t('locationReference')}
                                    text={location?.locationReference}
                                />
                                {/*<ItemInfoSpouse*/}
                                {/*    label={t('intersection')}*/}
                                {/*    // text={location?.intersection}*/}
                                {/*/>*/}
                                {/*<ItemInfoSpouse*/}
                                {/*    label={t('shopping-center-building')}*/}
                                {/*    // text={location?.shoppingCenterBuilding}*/}
                                {/*/>*/}
                                {/*<ItemInfoSpouse*/}
                                {/*    label={t('path')}*/}
                                {/*    // text={location?.path}*/}
                                {/*/>*/}
                                {/*<ItemInfoSpouse*/}
                                {/*    label={t('floor')}*/}
                                {/*    // text={location?.floor}*/}
                                {/*/>*/}
                                <ItemInfoSpouse
                                    label={t('building')}
                                    text={location?.address?.building}
                                />
                                <ItemInfoSpouse
                                    classNameContent={'lg:col-span-4'}
                                    label={t('location-reference')}
                                    text={location?.address?.reference}
                                    icon={<IconFontAwesome.FaLocationArrow className={styleIcon}/>}
                                />
                            </div>
                        </div>
                    </> : <NoRecords/>
                }
            />
        </div>
    )
}
